import { AxiosResponse } from "axios";

import API from "../../api";

import { Fleet } from "../../models/fleet";

const ROUTE_NAME = "route/fleets";

const RoutePlannerFleetService = {
  async create(fleet: Fleet): Promise<AxiosResponse<Fleet>> {
    return await API.post(`/${ROUTE_NAME}`, fleet);
  },
  async update(id: string, fleet: Fleet): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, fleet);
  },
  async delete(id: number): Promise<AxiosResponse<Fleet>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
};

export default RoutePlannerFleetService;
